import { createVanIconComponent } from "./van"

const Phone = createVanIconComponent("phone")
export default Phone
